export default __webpack_public_path__ + "static/media/information-icon.b5451ecd.png";